import { baseUrl } from "../../../../lib/routes/baseUrl";
import buildUrl from "../../../../lib/utils/buildUrl";

export const getAggregationRuleVersionsRoute = (id: number) => {
  return buildUrl({
    url: [baseUrl, "offerings-api", "aggregation-rules", id, "versions"].join("/"),
  });
};

export const getAggregationRulesVersionsRoute = (ids: number[]) => {
  return buildUrl({
    url: [baseUrl, "offerings-api", "aggregation-rules", "versions"].join("/"),
    searchParams: { ids },
  });
};

export const getAggregationRulesRoute = (params: { id: number; onDate?: string }) => {
  const { id, onDate } = params;
  if (onDate) {
    return buildUrl({
      url: [baseUrl, "offerings-api", "aggregation-rules", id].join("/"),
      searchParams: { onDate },
    });
  }
  return buildUrl({
    url: [baseUrl, "offerings-api", "aggregation-rules", id].join("/"),
  });
};

export const getCreateAggregationRuleRoute = () => {
  return buildUrl({
    url: [baseUrl, "offerings-api", "aggregation-rules"].join("/"),
  });
};

export const getUpdateAggregationRuleRoute = (params: {
  ruleId: number;
  fromDate?: string;
  force?: boolean;
}) => {
  const { ruleId, fromDate, force } = params;
  return buildUrl({
    url: [baseUrl, "offerings-api", "aggregation-rules", ruleId].join("/"),
    searchParams: {
      fromDate,
      force,
    },
  });
};

export const getCloseAggregationRuleRoute = (params: { ruleId: number; fromDate: string }) => {
  const { ruleId, fromDate } = params;
  return buildUrl({
    url: [baseUrl, "offerings-api", "aggregation-rules", ruleId].join("/"),
    searchParams: {
      fromDate,
    },
  });
};
